export const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const yesterday = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
};

export const datetimeString = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${day}/${month}/${year} ${hours}:${minutes} hs`;
};

export const isDateNewerThanADayAgo = (timestamp: number) => {
  const inputDate = new Date(timestamp);
  const currentDate = new Date();
  const oneDayAgo = new Date(currentDate.getTime() - DAY_IN_MS);
  return inputDate > oneDayAgo;
};

export const isDateNewerThanAWeekAgo = (dateString: string) => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * DAY_IN_MS);
  return inputDate > oneWeekAgo;
};

// dateString will be dd/MM/yyyy
export const parseDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/");
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};
